import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from './module';

export const CALENDAR_VIEW_INIT = prefix('CALENDAR_VIEW_INIT');

export const FORM_MODE_SETUP = prefix('FORM_MODE_SETUP');
export const RESTRICTIONS_ADD = prefix('RESTRICTIONS_ADD');
export const RESTRICTIONS_UPDATE = prefix('RESTRICTIONS_UPDATE');
export const RESTRICTIONS_SET = prefix('RESTRICTIONS_SET');
export const RESTRICTIONS_CLEAR = prefix('RESTRICTIONS_CLEAR');

export const FORM_RELATED_ENTITIES_FETCH = prefix('FORM_RELATED_ENTITIES_FETCH');
export const [
    FORM_RELATED_ENTITIES_FETCH_STARTED,
    FORM_RELATED_ENTITIES_FETCH_SUCCEEDED,
    FORM_RELATED_ENTITIES_FETCH_FAILED,
] = createAsyncActionTypes(FORM_RELATED_ENTITIES_FETCH);

export const RESTRICTION_FORM_INIT = prefix('RESTRICTION_FORM_INIT');
export const [RESTRICTION_FORM_INIT_STARTED, RESTRICTION_FORM_INIT_SUCCEEDED, RESTRICTION_FORM_INIT_FAILED] =
    createAsyncActionTypes(RESTRICTION_FORM_INIT);

export const BODY_CELL_SELECTED = prefix('BODY_CELL_SELECTED');
export const CELL_SELECTION_RESET = prefix('CELL_SELECTION_RESET');

export const SIDEBAR_CLOSED = prefix('SIDEBAR_CLOSED');
export const RESTRICTIONS_FILTER_CHANGED = prefix('RESTRICTIONS_FILTER_CHANGED');
